import React from 'react'
import { Box } from '@workwhile/ui'
import { DayforceJobsIssuesHeader } from './DayforceJobsIssuesHeader'
import { DayforceJobsIssuesFilterBar } from './DayforceJobsIssuesFilterBar'
import { DayforceJobsIssuesTable } from './DayforceJobsIssuesTable'

export const DayforceJobsIssuesMain = () => {
  return (
    <>
      <DayforceJobsIssuesHeader />
      <DayforceJobsIssuesFilterBar />
      <Box margin={3}>
        <DayforceJobsIssuesTable />
      </Box>
    </>
  )
}
